import { Asset } from '../v2/components/Asset'
import { Video } from '../v2/components/Asset/Video'
import DemonstrationForm from './DemonstrationForm'
import { Page, Asset as AssetT, Form, MiscAsset } from '@telesoft/types/payload-types'
import React, { ReactElement } from 'react'
import { CustomVideo } from './FullWidthDynamicBlock'

export type BlockProps = Extract<Page['hero'][0], { blockType: 'demonstration-form-hero' }>

export default function DemonstrationFormHero(block: BlockProps): ReactElement {
  const { title, subTitle, description, form, options, video } = block

  return (
    <div
      className={`bg-heading relative flex min-h-screen items-center justify-center ${
        options?.padding ? 'py-24' : 'py-0'
      } overflow-hidden`}
    >
      {options?.darken && <div className="bg-heading absolute inset-0"></div>}
      <div className="bg-telesoft absolute inset-0 mix-blend-soft-light"></div>
      <div className="absolute inset-0 opacity-40">
        <Video
          video={{
            ...(video as CustomVideo['video']),
          }}
          fill
        />
      </div>
      <DemonstrationForm
        title={title}
        subTitle={subTitle}
        description={description}
        form={form as Form}
      />
    </div>
  )
}
